import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

import { BASE_STYLES } from '../utils/constants';

export const Root = superstyled({
  name: 'Tracker',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => {
    return {
      ...BASE_STYLES,
      display: 'flex',

      flexDirection: 'column',
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3)
    };
  }
});

export const StatusContainer = superstyled({
  name: 'Tracker',
  slot: 'StatusContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    gap: theme.spacing(1)
  })
});

export const StatusDateContainer = superstyled({
  name: 'Tracker',
  slot: 'StatusDateContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1)
    }
  })
});
